import React, { useEffect, useState } from "react";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import { getInvoiceCreatedIndividual } from "../../../../redux/slices/sliceActions";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";
import customToasts from "../../../assets/reusableComponents/myToasts";
import { ToastContainer, Zoom } from "react-toastify";

const TenantTable = ({
  handleShowModal,
  setTenantData,
  setSelectedHouseId,
  setNewTenantInvoice,
}) => {
  //redux methods
  const dispatch = useDispatch();

  // data fetched from the store
  const { tenants, properties, houses } = useSelector(
    (state) => state.landlordslice
  );

  const formatedTenants = tenants.map((tenant) => convertTenantData(tenant));

  // Sort tenants by apartment number using alpha-numerical sorting
  const sortedTenants = formatedTenants.sort((a, b) => {
    const apartmentNumberA = a.apartmentNumber || "";
    const apartmentNumberB = b.apartmentNumber || "";

    // Extract the numeric part from the apartment numbers
    const numA = parseInt(apartmentNumberA.replace(/^\D+/g, ""), 10) || 0;
    const numB = parseInt(apartmentNumberB.replace(/^\D+/g, ""), 10) || 0;

    // Extract letter parts
    const lettersA = apartmentNumberA.replace(/\d/g, "").toLowerCase();
    const lettersB = apartmentNumberB.replace(/\d/g, "").toLowerCase();

    // If both are pure numbers, sort numerically
    if (lettersA === "" && lettersB === "") {
      return numA - numB;
    }

    // If one is pure number, place it first
    if (lettersA === "") return -1;
    if (lettersB === "") return 1;

    // If both are alphanumeric, sort by letters first, then by numeric part
    const letterComparison = lettersA.localeCompare(lettersB);
    if (letterComparison !== 0) return letterComparison;
    return numA - numB;
  });

  useEffect(() => {
    console.log("Formatted Tenants:", sortedTenants);
  }, [sortedTenants]);

  const [expandedRow, setExpandedRow] = useState(null);
  const [hover, setHover] = useState(false);
  const [hover2, setHover2] = useState(false);

  const handleRowClick = (tenantId) => {
    setExpandedRow(expandedRow === tenantId ? null : tenantId);
  };

  const styles = {
    card: {
      width: "97%",
      display: "flex",
      justifyContent: "space-between",
      marginTop: vh(10),
      backgroundColor: "white",
      boxShadow: "rgba(0, 0, 0, 0.28) 0px 0px 5px 0px",
      padding: `${vh(7)} ${vh(15)}`,
      borderRadius: vw(10),
      alignItems: "center",
      cursor: "pointer",
    },
    firstSection: {
      display: "flex",
      alignItems: "center",
      gap: vw(20),
    },
    profilePicture: {
      width: vh(50),
      height: vh(50),
      borderRadius: "50%",
    },
    placeHolder: {
      width: vh(50),
      height: vh(50),
      borderRadius: "50%",
      backgroundColor: "#192A3A",
    },
    dateJoined: {
      color: "#9d9d9d",
      fontSize: vh(14),
      fontFamily: "Karla, sans-serif",
      marginTop: vh(4),
    },
    apartmentNumber: {
      color: "#B39359",
    },
    expandedContent: {
      width: "97%",
      margin: `${vh(20)} 0px`,
      padding: "1rem",
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(221, 221, 221)",
      borderRadius: vw(5),
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    expandedTitle: {
      color: "#192A3A",
      fontSize: vh(18),
      fontWeight: "600",
      marginBottom: vh(10),
      fontFamily: "Karla, sans-serif",
    },
    expandedRow: {
      display: "flex",
      justifyContent: "space-between",
      width: "40%",
      marginBottom: vh(10),
    },
    expandedSubTitle: {
      fontSize: vh(16),
      fontFamily: "Poppins,sans-serif",
      fontWeight: "200",
    },
    expandedDetails: {
      fontFamily: "Poppins,sans-serif",
      fontWeight: "400",
      fontSize: vh(16),
    },
    button: {
      backgroundColor: hover ? "#B39359" : "#192A3A",
      color: "white",
      padding: `${vh(7)} ${vh(10)}`,
      borderRadius: vw(5),
      cursor: "pointer",
      marginTop: vh(10),
      fontSize: vh(16),
      fontWeight: "200",
      transition: "background-color 0.3s ease",
    },
  };

  return (
    <div>
      {sortedTenants.map((tenant) => (
        <>
          <div style={styles.card} onClick={() => handleRowClick(tenant.id)}>
            <div style={styles.firstSection}>
              {tenant?.profilePicture ? (
                <div>
                  <img
                    style={styles.profilePicture}
                    src={`${tenant.profilePicture}`}
                    alt={`${tenant.name}'s profile`}
                  />
                </div>
              ) : (
                <div style={styles.placeHolder}></div>
              )}
              <div>
                <div>{tenant.name}</div>
                <div style={styles.dateJoined}>{tenant.dateJoined}</div>
              </div>
            </div>
            <div> {tenant.email}</div>
            <div style={styles.apartmentNumber}>{tenant.apartmentNumber}</div>
          </div>
          {expandedRow === tenant.id && (
            <div style={styles.expandedContent}>
              <div style={styles.expandedTitle}>Tenant Details</div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Tenant Id:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.id}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Phone Number:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.phoneNumber}</div>
              </div>
              {/* <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>National id Number:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.nationalID}</div>
              </div> */}
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>House Type:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.houseType}</div>
              </div>
              <div style={styles.expandedRow}>
                <div style={styles.expandedSubTitle}>Email:</div>{" "}
                <div style={styles.expandedDetails}>{tenant.email}</div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: vw(10),
                }}
              >
                <div
                  style={styles.button}
                  onClick={() => {
                    handleShowModal("modify tenant");
                    setTenantData({
                      id: tenant.id,
                      name: tenant.name,
                      entryDate: tenant.dateJoined,
                      apartmentNumber: tenant.apartmentNumber,
                      email: tenant.email,
                      houseType: tenant.houseType,
                      firstName: tenant.name.split(" ")[0],
                      lastName: tenant.name.split(" ")[1],
                      phoneNumber: tenant.phoneNumber,
                      nationalId: tenant.nationalID,
                    });

                    const house = houses.find(
                      (house) => house._id === tenant.house
                    );
                    setSelectedHouseId(house._id);
                  }}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  Edit Tenant
                </div>

                {!tenant.hasMadeFirstPayment && !tenant.isExistingTenant && (
                  <div
                    style={{
                      ...styles.button,
                      backgroundColor: hover2 ? "#B39359" : "#192A3A",
                    }}
                    onClick={() => {
                      // customToasts
                      //   .promise(
                      //     dispatch(
                      //       getInvoiceCreatedIndividual({
                      //         houseId: tenant.house,
                      //       })
                      //     ).unwrap(),
                      //     {
                      //       pending: "Checking for existing invoice",
                      //       success: "Invoice found successfully",
                      //       error: "No invoice found",
                      //     }
                      //   )
                      //   .then((response) => {
                      //     console.log("Invoice response:", response);

                      //     // Handle the response data here
                      //     if (response.status === "success") {
                      //       setTenantData({
                      //         id: tenant.id,
                      //         name: tenant.name,
                      //         entryDate: tenant.dateJoined,
                      //         apartmentNumber: tenant.apartmentNumber,
                      //         email: tenant.email,
                      //         houseType: tenant.houseType,
                      //         firstName: tenant.name.split(" ")[0],
                      //         lastName: tenant.name.split(" ")[1],
                      //         phoneNumber: tenant.phoneNumber,
                      //         nationalId: tenant.nationalID,
                      //         houseId: tenant.house,
                      //       });
                      //       const house = houses.find(
                      //         (house) => house._id === tenant.house
                      //       );
                      //       setSelectedHouseId(house._id);
                      //     }
                      //     handleShowModal("prompt payment");
                      //   })
                      //   .catch((error) => {
                      //     console.log(
                      //       "Individual Invoice found details:",
                      //       error
                      //     );
                      //     setTenantData({
                      //       id: tenant.id,
                      //       name: tenant.name,
                      //       entryDate: tenant.dateJoined,
                      //       apartmentNumber: tenant.apartmentNumber,
                      //       email: tenant.email,
                      //       houseType: tenant.houseType,
                      //       firstName: tenant.name.split(" ")[0],
                      //       lastName: tenant.name.split(" ")[1],
                      //       phoneNumber: tenant.phoneNumber,
                      //       nationalId: tenant.nationalID,
                      //       houseId: tenant.house,
                      //     });
                      //     const house = houses.find(
                      //       (house) => house._id === tenant.house
                      //     );
                      //     setSelectedHouseId(house._id);
                      //     setNewTenantInvoice(error?.data);
                      //     handleShowModal("prompt payment");
                      //   });

                      setTenantData({
                        id: tenant.id,
                        name: tenant.name,
                        entryDate: tenant.dateJoined,
                        apartmentNumber: tenant.apartmentNumber,
                        email: tenant.email,
                        houseType: tenant.houseType,
                        firstName: tenant.name.split(" ")[0],
                        lastName: tenant.name.split(" ")[1],
                        phoneNumber: tenant.phoneNumber,
                        nationalId: tenant.nationalID,
                        houseId: tenant.house,
                      });
                      const house = houses.find(
                        (house) => house._id === tenant.house
                      );
                      setSelectedHouseId(house._id);

                      handleShowModal("prompt payment");
                    }}
                    onMouseEnter={() => setHover2(true)}
                    onMouseLeave={() => setHover2(false)}
                  >
                    Prompt Payment
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ))}

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Zoom}
      />
    </div>
  );
};

function convertTenantData(tenant) {
  console.log("Converting tenant data:", tenant);
  return {
    id: tenant?.user?._id || "error, not found",
    name: tenant?.user?.name || "John Doe",
    dateJoined:
      new Date(tenant.entry_date).toLocaleString("default", {
        month: "long",
        year: "numeric",
      }) || "March 2024",
    apartmentNumber: tenant.house_no, // Placeholder
    email: tenant?.user?.email || "error, not found",
    phoneNumber: tenant?.user?.phone || "error, not found",
    houseType:
      tenant?.house_type === "single"
        ? "Bed Sitter"
        : tenant?.house_type === "one-bedroom"
        ? "One Bedroom"
        : tenant?.house_type === "two-bedroom"
        ? "Two Bedroom"
        : tenant?.house_type === "three-bedroom"
        ? "Three Bedroom"
        : tenant?.house_type === "office"
        ? "Office"
        : tenant?.house_type === "bed-sitter"
        ? "Bed Sitter"
        : "Shop",
    nationalID: tenant?.user?.ID || "12345678",
    // Use first image if available, otherwise empty string
    profilePicture:
      Array.isArray(tenant?.user?.image) && tenant.user.image.length > 0
        ? `${process.env.REACT_APP_IMAGE_ENDPOINT}/${tenant.user.image[0]}`
        : "",
    house: tenant.house,
    hasMadeFirstPayment: tenant.hasMadeFirstPayment,
    isExistingTenant: tenant.isExisting,
  };
}

export default TenantTable;
